import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { Blocked } from '../../../../../../common/components/Blocked';
import { useWidget } from '../../../../../../contexts/widgets';
import { Avatar } from './Avatar';
import { Badges } from './Badges';
import { Buttons } from './Buttons';
import styles from './Content.scss';
import { Followers } from './Followers';
import { Name } from './Name';
import { Title } from './Title';

export const Content: FC = () => {
  const { site, globalSettings, computed, member } = useWidget();

  const {
    badgesSettings,
    inCommunity,
    showAsBlocked,
    showAsBlockedByMember,
    showTitle,
  } = computed;
  const { isSocial } = site;

  const hasTitle = !!member.title && showTitle;
  const showFollowers = globalSettings.ffLightboxEnabled
    ? globalSettings.ffLightboxInstalled
    : globalSettings.showFollowers;
  const isFollowersVisible = isSocial && showFollowers && inCommunity;
  const isOnlyNameVisible =
    !badgesSettings.badges.length && !hasTitle && !isFollowersVisible;

  const renderAsEmpty = showAsBlockedByMember;

  return (
    <div
      className={classNames({
        [styles.container]: true,
        [styles.isOnlyNameVisible]: isOnlyNameVisible,
      })}
    >
      <div className={styles.layout}>
        <div className={styles.content}>
          <div className={styles.detailsAndPhoto}>
            <Avatar />
            {!renderAsEmpty && (
              <div className={styles.memberDetails}>
                <Name />
                {isFollowersVisible && <Followers />}
                {showTitle && <Title />}
                {isSocial && showAsBlocked && (
                  <Blocked className={styles.blocked} />
                )}
                {badgesSettings.badges.length > 0 && <Badges />}
              </div>
            )}
          </div>
          {!renderAsEmpty && <Buttons />}
        </div>
      </div>
    </div>
  );
};
